import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { DropzoneArea } from 'react-mui-dropzone';
import Button from '@mui/material/Button';

import Loader from '../Loader';

import config from '../../config/config';

import './CMSUpload.css';
// import s from 'react-aws-s3';

function CMSUpload() {
  const [running, setRunning] = useState(false);
  const [file, setFile] = useState(null);
  const [date, setDate] = useState('');

  const handleFileChange = (e) => {
    setFile(e[0]);
  }

  const handleSubmit = async () => {
    setRunning(true);
    if (file && date) {
      const formData = new FormData();
      formData.append('name', "CMS-Data");
      formData.append('file', file);
      try {
        
        const res = await axios.put(`${config.apiUrl}/api/cms-data/upload-file/${date}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (res.status === 200) {
          console.log('File uploaded');
          setFile(null);
          setDate('');
          setRunning(false);
        }
        else {
          console.log('Error uploading file');

          setRunning(false);
        }
      } catch (error) {
        console.log(error);
        setRunning(false);
      }

    }
    else {
      console.log('Please select a file and date');
      setRunning(false);
    }
  }

  return (
    <div>
      <DropzoneArea
        acceptedFiles={['.csv', 'application/vnd.ms-excel', 'text/csv']}
        showPreviews={true}
        showPreviewsInDropzone={false}
        maxFileSize={5000000}
        multiple={false}
        maxFiles={1}
        onChange={(e) => handleFileChange(e)}
      />

      <div>
        <label>Batch Date</label>
        <br />
        <input type="date" name="batch-date" value={date} onChange={(e) => setDate(e.target.value)} />
      </div>

      <Button
        disabled={running || !file || !date}
        onClick={handleSubmit}
      >Submit</Button>

      {running &&
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.5)',
        }}>
          <div style={{

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: 300,
            height: 250,
            backgroundColor: 'white',
            borderRadius: 10
          }}>
            <h3 style={{ marginBottom: 10 }}>Running</h3>
            <Loader loading={running} height={50} />
          </div>
        </div>
      }
    </div>
  )
}

export default CMSUpload;